import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { BsApiService, GenericResponseCode, SimpleGlobalModalService } from '@brightside-web/desktop/data-access/core-services';
import { SurveyQuestionnaireService } from '../survey-questionnaire.service';
import { Survey, SurveyStatus } from '../models/survey.model';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'brightside-web-survey-main',
    templateUrl: './survey-main.component.html',
    styleUrls: ['./survey-main.component.scss'],
    imports: [CommonModule, RouterOutlet],
    providers: []
})
export class SurveyMainComponent implements OnInit {

  @Input() externalControl = false;
  @Output() surveyStatus = new EventEmitter<Survey>();
  @Input() displayBackButton = true;

  private _surveyQuestionnaireService = inject(SurveyQuestionnaireService);

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _surveyQuetionnaireService: SurveyQuestionnaireService,
    private _simpleModalService: SimpleGlobalModalService
  ) {

  }

  ngOnInit(): void {
    this._route.params.subscribe(params => {
      this.loadSurveyData(params['type']);
    });
  }

  private loadSurveyData(type: string) {
    if (type) {
      this._surveyQuetionnaireService.setSurveyType(type);
      this._surveyQuetionnaireService.getSurveyData(type).subscribe((surveyResponse) => {
        if (surveyResponse.result.code === GenericResponseCode.SERVICE_OK) {
          this.handleSurveyResponse(surveyResponse.payload);
        } else if (surveyResponse.result.code === GenericResponseCode.INVALID_FIELD) {
          this.handleSurveyError();
        }
      });
    }
  }

  private handleSurveyResponse(surveyData: Survey): void {
    this._surveyQuetionnaireService.setSurveyData(surveyData);
    this.surveyStatus.emit(surveyData);
    if (this.externalControl) {
      return;
    }

    if (surveyData.status === SurveyStatus.COMPLETED) {
      this._router.navigate(['completed'], { relativeTo: this._route });
    } else if (
      surveyData.status === SurveyStatus.ABANDONED ||
      surveyData.status === SurveyStatus.TERMINATED
    ) {
      this._router.navigate(['abandoned'], { relativeTo: this._route });
    } else {
      if (surveyData.intro) {
        this._router.navigate(['intro'], { relativeTo: this._route });
      } else {
        this._router.navigate(['view'], { relativeTo: this._route });
      }
    }
  }

  private handleSurveyError(): void {
    this._simpleModalService.createGenericErrorModal('survey_fetch', () => {
      this._surveyQuestionnaireService.backToHomeCalled('failed');
      this._simpleModalService.clearModal();
    },
    'BUTTON_CONTINUE',
      () => {
        this._surveyQuestionnaireService.backToHomeCalled('failed');
        this._simpleModalService.clearModal();
      }
    );
  }
}
